
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legends",
      function () {
        return require("private-next-pages/legends/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legends"])
      });
    }
  